import { useContext } from 'react'

import { Tag } from 'antd'
import { faBatteryFull, faCalendar, faClinicMedical, faStethoscope, faSyringe, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'
import { useSelector } from 'react-redux'

import { isObject } from '../../../utils'
import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'
import { getInstitutionName, getSectorName, getStateTag, InternshipRequest } from '../../../utils/entities/internshipRequest'
import PeriodsEllipsedList from '../../../Components/shared/EllipsedLists/PeriodsEllipsedList'
import { IndividualInternshipRequestModalContext } from '../../../Providers/Forms/IndividualInternshipRequest/IndividualInternshipRequestModal'
import InternshipRequestFilesIcon from './InternshipRequestFilesIcon'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { ColorsPalette } from '../../../config/colors'
import PopoverIcon from '../../../Components/antd/Icons/PopoverIcon'

const { SMALL } = FontSizes

const IndividualInternshipRequestCard = ({ internshipRequest, callback, onDelete }) => {
  const iir = useContext(IndividualInternshipRequestModalContext)

  const t = useSelector(selectTranslate)

  const institutionName = getInstitutionName(internshipRequest) ?? t('common.unknown_institution')
  const sectorName = getSectorName(internshipRequest) ?? t('common.unknown_sector')
  const actTypeName = isObject(internshipRequest.actType) ? internshipRequest.actType.name : null
  const className = isObject(iir) ? 'cu-ptr' : ''
  const stateTag = getStateTag(internshipRequest.state)

  const handleClick = () => {
    if (isObject(iir)) {
      iir.setHandler(handler => ({ ...handler, data: new InternshipRequest(internshipRequest), callback }))
    }
  }

  return (
    <div className='flex-row w-100 ai-ctr hover-grey pd-4'>
      <div className={`flex-column w-90 ${className}`} onClick={handleClick}>
        <IconLabel icon={faClinicMedical} text={institutionName} fontSize={SMALL} />
        <IconLabel icon={faStethoscope} text={sectorName} fontSize={SMALL} />
        {actTypeName !== null && <IconLabel icon={faSyringe} text={actTypeName} fontSize={SMALL} />}
        <IconLabel icon={faCalendar} text={<PeriodsEllipsedList data={internshipRequest.requestPeriods} />} fontSize={SMALL} />
        <IconLabel icon={faBatteryFull} text={<Tag color={stateTag.color}> {t(stateTag.label)} </Tag>} fontSize={SMALL} />
      </div>
      <InternshipRequestFilesIcon internshipRequest={internshipRequest} />
      {isFunction(onDelete) && (
        <>
          <div className='pd-4' />
          <PopoverIcon
            content='internship_request_card.delete_request.content'
            title='internship_request_card.delete_request.title'
            icon={faTrash}
            color={ColorsPalette.RED_ICON}
            onConfirm={() => onDelete(internshipRequest)}
          />
        </>
      )}
    </div>
  )
}

export default IndividualInternshipRequestCard
